<div *ngIf="!isLoading">	
	<apx-chart
					id="riskAnalysisBar"
					[chart]="options.chart"
					[series]="options.series"
					[grid]="options.grid"
					[colors]="options.colors"
					[legend]="options.legend"
					[plotOptions]="options.plotOptions"
					[dataLabels]="options.dataLabels"
					[xaxis]="options.xaxis"
					[yaxis]="options.yaxis"
	>
	</apx-chart>
</div>
